import { __extends } from "tslib";
import React from 'react';
import { ConfigContextConsumer } from '../config-context';
var getMemo = function (fetchMemoizationId, configContext) {
    return configContext.ssrMemo ? configContext.ssrMemo[fetchMemoizationId] : null;
};
var setMemo = function (fetchMemoizationId, fetchData, configContext) {
    if (configContext.ssrMemo) {
        configContext.ssrMemo[fetchMemoizationId] = fetchData;
    }
};
var isBrowser = function () { return typeof window !== 'undefined'; };
var getFetcher = function () {
    var data;
    var promise;
    var ssrCount = 0;
    return function (_a) {
        var initialFetch = _a.initialFetch;
        if (ssrCount++ > 10) {
            return {};
        }
        if (data) {
            ssrCount = 0;
            return data;
        }
        if (!promise) {
            promise = initialFetch().then(function (res) {
                data = res;
            });
        }
        throw promise;
    };
};
var FetcherHOC = /** @class */ (function (_super) {
    __extends(FetcherHOC, _super);
    function FetcherHOC(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, fetcher = _a.fetcher, initialFetch = _a.initialFetch, fetchMemoizationId = _a.fetchMemoizationId, configContext = _a.configContext;
        if (isBrowser()) {
            var memo = getMemo(fetchMemoizationId, configContext);
            _this.state = memo
                ? { fetchData: memo }
                : { fetchData: fetcher({ initialFetch: initialFetch }) };
        }
        return _this;
    }
    FetcherHOC.prototype.reFetch = function (fetch) {
        var _this = this;
        // tslint:disable-next-line: no-floating-promises
        fetch().then(function (res) { return _this.setState({ fetchData: res }); });
    };
    FetcherHOC.prototype.render = function () {
        var _a = this.props, fetcher = _a.fetcher, initialFetch = _a.initialFetch, fetchMemoizationId = _a.fetchMemoizationId, children = _a.children, configContext = _a.configContext;
        var fetchData = isBrowser()
            ? this.state.fetchData
            : fetcher({ initialFetch: initialFetch });
        !isBrowser() && setMemo(fetchMemoizationId, fetchData, configContext);
        return (React.createElement(React.Fragment, null, children({
            fetchData: fetchData,
            reFetch: isBrowser() ? this.reFetch.bind(this) : function () { },
        })));
    };
    return FetcherHOC;
}(React.Component));
var WithFetcher = /** @class */ (function (_super) {
    __extends(WithFetcher, _super);
    function WithFetcher(props) {
        var _this = _super.call(this, props) || this;
        _this.fetcher = getFetcher();
        return _this;
    }
    WithFetcher.prototype.render = function () {
        var _this = this;
        var _a = this.props, initialFetch = _a.initialFetch, _b = _a.fetchMemoizationId, fetchMemoizationId = _b === void 0 ? '' : _b, children = _a.children, loader = _a.loader;
        return (React.createElement(ConfigContextConsumer, null, function (configContext) { return (React.createElement(React.Suspense, { fallback: loader },
            React.createElement(FetcherHOC, { fetcher: _this.fetcher, initialFetch: initialFetch, fetchMemoizationId: fetchMemoizationId, configContext: configContext }, children))); }));
    };
    return WithFetcher;
}(React.Component));
export { WithFetcher };
//# sourceMappingURL=with-fetcher.js.map